"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Iterations = void 0;
var Iterations;
(function (Iterations) {
    Iterations["Infinite"] = "u-infinite";
    Iterations["Once"] = "u-once";
})(Iterations = exports.Iterations || (exports.Iterations = {}));
//# sourceMappingURL=Iterations.js.map